import messagesUz from '@/lang/uz';
import messagesRu from '@/lang/ru';

const messages = {
    ...messagesUz,
    ...messagesRu
}

export default messages;